import AddToCartContent from './AddToCartContent';


export default AddToCartContent;
